import { Box } from "@chakra-ui/react";
import StepperButtons from "./StepperButtons";
import { HighlightNumberType } from "../elements/PythonCodeEditor";
import JsonRender from "../JsonRender";

type IProps = {
  explanation: HighlightNumberType | null;
  currentIdx: number;
  onPrevClick: () => void;
  onPrevIsDisabled: boolean;
  onNextClick: () => void;
  onNextIsDisabled: boolean;
  explanationsCount?: number;
};

const EditorExplanation = ({
  explanation,
  currentIdx,
  explanationsCount,
  ...rest
}: IProps) => {
  return (
    <Box>
      <Box pt="1rem" pb={{ base: "0rem", md: "1rem" }}>
        {explanation && (
          <JsonRender
            mode="view"
            lessonId=""
            content={[
              {
                id: currentIdx,
                component: explanation.component,
                props: explanation.props,
              } as any,
            ]}
          />
        )}
      </Box>
      {!explanationsCount || explanationsCount === 1 ? (
        <></>
      ) : (
        <StepperButtons {...rest} />
      )}
    </Box>
  );
};

export default EditorExplanation;
